<template>
    <v-container
        v-resize="onResize"
        fluid
        class="overflow-y-hidden pa-3"
        ref="container"
        style="height:100%"
    >
        <v-progress-linear v-if="loading" indeterminate color="primary" />
        <v-data-table
            v-else
            id="virtual-scroll-table"
            disable-pagination
            hide-default-footer
            :headers="headers"
            :items="filteredItems"
            :mobile-breakpoint="0"
            :height="height"
            item-key="id"
            class="elevation-0 poc-table"
            :loading="loading"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    :style="{ 'background-color': '#eeeeee' }"
                    :class="
                        $vuetify.breakpoint.xs
                            ? 'mt-0 mx-0 pt-3 pb-0 pb-3 align-center'
                            : 'mt-0 mx-0 pt-3 pb-0 pb-3 align-center'
                    "
                >
                    <v-col cols="12" class="d-flex">
                        <h2 class="ml-4">POC</h2>
                        <v-spacer v-if="!$vuetify.breakpoint.xs" />
                        <v-btn
                            v-if="isSaveEnabled"
                            color="success"
                            rounded
                            class="mr-2"
                            @click="saveChanges"
                        >
                            Save
                        </v-btn>
                        <v-btn
                            depressed
                            color="primary"
                            @click="openUploadFile"
                            rounded
                            class="ml-2"
                            :disabled="!uploadPocPermission"
                        >
                            <v-icon>mdi-plus</v-icon>
                            {{ !$vuetify.breakpoint.xs ? 'New' : '' }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    no-gutter
                    :class="
                        $vuetify.breakpoint.xs
                            ? 'mt-0 mx-0 pt-4 pb-0 pb-4 align-center'
                            : 'mt-0 mx-0 pt-4 pb-0 pb-4 align-center'
                    "
                    style="background-color: #eeeeee"
                >
                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-3 pl-2 pr-5 mx-3"
                                min-width="180px"
                                height="75px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 mx-2 pt-0 white--text"
                                        :color="insights[0].color"
                                        label
                                        style="height: 50px"
                                    >
                                        <v-icon center>
                                            {{ insights[0].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                style="font-size: 14px; font-weight: bold;"
                                                >{{ insights[0].title }}</span
                                            >
                                        </div>
                                        <p class="text-h6 black--text">
                                            {{
                                                formatNumber(
                                                    currency ?? 'COP',
                                                    pocTRM ?? '4100'
                                                )
                                            }}
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>
                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-3 pl-2 pr-5 mx-3"
                                min-width="180px"
                                height="75px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 mx-2 pt-0 white--text"
                                        :color="insights[1].color"
                                        label
                                        style="height: 50px"
                                    >
                                        <v-icon center>
                                            {{ insights[1].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                style="font-size: 14px; font-weight: bold;"
                                                >{{ insights[1].title }}</span
                                            >
                                        </div>
                                        <p class="text-h6 black--text">
                                            {{ cutOffDate ?? '0' }}
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.job`]="{ header }">
                <v-text-field
                    class="py-2 mt-2 custom-label"
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.client`]="{ header }">
                <v-text-field
                    class="py-2 mt-2 custom-label"
                    :label="header.text"
                    v-model="clientToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.reference`]="{ header }">
                <v-text-field
                    class="py-2 mt-2 custom-label"
                    :label="header.text"
                    v-model="referenceToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.orderCode`]="{ header }">
                <v-text-field
                    class="py-2 mt-2 custom-label"
                    :label="header.text"
                    v-model="orderToFilter"
                    dense
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.totalAmountBeforeTaxes`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.totalAmountBeforeTaxes ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.b2b`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.b2b ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.b2d`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.b2d ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.estimatedMargin`]="{ item }">
                <div class="my-4">
                    <v-text-field
                        v-model.number="item.tempMargin"
                        type="number"
                        dense
                        :rules="[v => v >= 0 || 'only positive values']"
                        :suffix="'%'"
                        @input="() => updateMargin(item)"
                    ></v-text-field>
                </div>
            </template>
            <template v-slot:[`item.estimatedRevenues`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.estimatedRevenues ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.estimatedGrossProfit`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.estimatedGrossProfit ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.estimatedCost`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.estimatedCost ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.costs`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.costs ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.payroll`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.payroll ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.costOfRevenues`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.costOfRevenues ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.percentageCompleted`]="{ item }">
                <div class="my-4">
                    {{ ((item.percentageCompleted ?? 0) * 100).toFixed(2) }} %
                </div>
            </template>
            <template v-slot:[`item.grossProfit`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.grossProfit ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.revenuesEarned`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.revenuesEarned ?? 0) }}
                </div>
            </template>
            <template v-slot:[`item.billedToDateForThisMonth`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{
                        formatNumber('COP', item.billedToDateForThisMonth ?? 0)
                    }}
                </div>
            </template>
            <template v-slot:[`item.estimatedCostToComplete`]="{ item }">
                <div class="d-flex justify-end align-right">
                    {{ formatNumber('COP', item.estimatedCostToComplete ?? 0) }}
                </div>
            </template>
        </v-data-table>

        <!--UPLOAD FILE-->
        <v-dialog v-model="openDialog" persistent max-width="400">
            <UploadPOC
                v-if="openDialog"
                :oldData="items"
                :settingExchange="settingExchange"
                @close="closeUploadFile"
                @addPOC="addPOC"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import { storage } from '@/services/firebase'

export default {
    name: 'POC',
    components: {
        UploadPOC: () => import('@/components/Projects/UploadPOC.vue'),
    },
    data: () => ({
        height: 0,
        loading: false,
        isSaveEnabled: false,
        openDialog: false,
        items: [],
        headers: [
            {
                text: 'Order CO',
                value: 'orderCode',
                sortable: false,
                width: 100,
            },
            {
                text: 'Project ID',
                value: 'reference',
                sortable: false,
                width: 100,
            },
            {
                text: 'Job',
                value: 'job',
                sortable: false,
                width: 250,
            },
            {
                text: 'Client',
                value: 'client',
                sortable: false,
                width: 150,
            },
            {
                text: 'Total amount before taxes (COP)',
                value: 'totalAmountBeforeTaxes',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Balance to bill (COP)',
                value: 'b2b',
                sortable: false,
                width: 150,
                align: 'right',
            },
            {
                text: 'Billed to date (COP)',
                value: 'b2d',
                sortable: false,
                width: 150,
                align: 'right',
            },
            {
                text: 'Estimated margin',
                value: 'estimatedMargin',
                sortable: false,
                width: 150,
            },
            {
                text: 'Estimated revenues (COP)',
                value: 'estimatedRevenues',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Estimated gross profit (COP)',
                value: 'estimatedGrossProfit',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Estimated cost (COP)',
                value: 'estimatedCost',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Costs (COP)',
                value: 'costs',
                sortable: false,
                width: 150,
                align: 'right',
            },
            {
                text: 'Payroll (COP)',
                value: 'payroll',
                sortable: false,
                width: 150,
                align: 'right',
            },
            {
                text: 'Cost of revenues (COP)',
                value: 'costOfRevenues',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: '% completed',
                value: 'percentageCompleted',
                sortable: false,
                width: 110,
            },
            {
                text: 'Revenues earned (COP)',
                value: 'revenuesEarned',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Gross profit (COP)',
                value: 'grossProfit',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Billed to date for this month (COP)',
                value: 'billedToDateForThisMonth',
                sortable: false,
                width: 200,
                align: 'right',
            },
            {
                text: 'Estimated cost to complete (COP)',
                value: 'estimatedCostToComplete',
                sortable: false,
                width: 200,
                align: 'right',
            },
        ],
        projectToFilter: null,
        clientToFilter: null,
        dateToFilter: null,
        referenceToFilter: null,
        orderToFilter: null,
        uploadPocPermission: false,
        insights: [
            {
                color: '#ffa414',
                icon: 'mdi-currency-usd',
                iconColor: '#1A5276',
                title: 'TRM',
            },
            {
                color: '#20844c',
                icon: 'mdi-calendar-outline',
                iconColor: '#1A5276',
                title: `CUT-OFF DATE`,
            },
        ],
        cutOffDate: null,
        pocTRM: null,
        currency: 'COP',
        settingExchange: {},
        companyId: JSON.parse(localStorage.getItem('company')),
    }),
    async mounted() {
        try {
            this.loading = true
            this.items = await API.getAllPOC()
            this.items = this.items.map(item => ({
                ...item,
                tempMargin: item.estimatedMargin * 100,
            }))
            this.cutOffDate = this.items[0].cutOffDate
            this.pocTRM = this.items[0].trm
            const {
                data: { settings },
            } = await API.getSettings()
            const indexExchanges = settings.findIndex(
                u => u.name === 'Exchange'
            )
            this.settingExchange = settings[indexExchanges]

            const {
                data: { user },
            } = await API.getMyInfo()
            this.uploadPocPermission = user.permissions.includes('uploadPOC')
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    updated() {
        this.onResize()
    },
    computed: {
        filteredItems() {
            let conditions = []

            if (this.referenceToFilter) {
                conditions.push(this.filterByReference)
            }

            if (this.orderToFilter) {
                conditions.push(this.filterByOrder)
            }

            if (this.dateToFilter) {
                conditions.push(this.filterByDate)
            }

            if (this.projectToFilter) {
                conditions.push(this.filterByProject)
            }

            if (this.clientToFilter) {
                conditions.push(this.filterByClient)
            }

            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }

            return this.items
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        filterByReference(item) {
            return `${item.reference}`
                .toLowerCase()
                .includes(this.referenceToFilter.toLowerCase())
        },
        filterByOrder(item) {
            return `${item.orderCode}`
                .toLowerCase()
                .includes(this.orderToFilter.toLowerCase())
        },
        filterByDate(item) {
            return `${item.year}-${item.month}`
                .toLowerCase()
                .includes(this.dateToFilter.toLowerCase())
        },
        filterByClient(item) {
            return item.client
                .toLowerCase()
                .includes(this.clientToFilter.toLowerCase())
        },
        filterByProject(item) {
            return item.job
                .toLowerCase()
                .includes(this.projectToFilter.toLowerCase())
        },
        formatNumber(currency, value) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                maximumFractionDigits: currency == 'USD' ? 2 : 0,
            }).format(parseFloat(value))
        },
        addPOC(data) {
            this.items = data.map(item => ({
                ...item,
                tempMargin: item.estimatedMargin * 100,
            }))
            this.cutOffDate = this.items[0].cutOffDate
            this.pocTRM = this.items[0].trm
        },
        closeUploadFile() {
            this.openDialog = false
        },
        openUploadFile() {
            this.openDialog = true
        },
        onFieldChange(item) {
            this.reCalculateData(item)
            this.isSaveEnabled = true
        },
        async saveChanges() {
            try {
                const dataToSave = this.items.map(obj => {
                    const newItem = { ...obj }
                    delete newItem.tempMargin
                    return newItem
                })
                const blob = new Blob([JSON.stringify(dataToSave)], {
                    type: 'application/json',
                })
                const path = `${this.companyId}/POC/POCData.json`
                const storageRef = storage().ref(path)
                await storageRef.put(blob)
                this.isSaveEnabled = false
            } catch (error) {
                console.error('Error when saving changes:', error)
            }
        },
        updateMargin(item) {
            item.estimatedMargin = item.tempMargin / 100
            this.onFieldChange(item)
        },
        reCalculateData(item) {
            item.estimatedGrossProfit =
                item.estimatedRevenues * item.estimatedMargin
            item.estimatedCost = Math.abs(
                item.estimatedRevenues - item.estimatedGrossProfit
            )
            item.percentageCompleted = item.costOfRevenues / item.estimatedCost

            item.revenuesEarned =
                item.percentageCompleted * item.estimatedRevenues
            item.grossProfit = item.revenuesEarned - item.costOfRevenues
            item.revenuesEarned =
                item.estimatedRevenues * item.percentageCompleted
            item.grossProfit = item.revenuesEarned - item.costOfRevenues
            item.estimatedCostToComplete =
                item.estimatedCost - item.costOfRevenues

            const cleaned = { ...item }

            return cleaned
        },
        onResize() {
            const {
                container: { clientHeight: containerHeight },
            } = this.$refs
            this.height = containerHeight - 180
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead th {
    background-color: #eeeeee !important;
}
.custom-label .v-label {
    font-size: 12px;
}
#virtual-scroll-table {
    width: 100%;
    overflow-y: auto;
}
.poc-table td:nth-child(1) {
    position: sticky;
    left: 0;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 3;
}
.poc-table th:nth-child(1) {
    position: sticky;
    left: 0;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 4;
}
.poc-table td:nth-child(2) {
    position: sticky;
    left: 100px;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 3;
}
.poc-table th:nth-child(2) {
    position: sticky;
    left: 100px;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 4;
}
.poc-table td:nth-child(3) {
    position: sticky;
    left: 200px;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 3;
}
.poc-table th:nth-child(3) {
    position: sticky;
    left: 200px;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 4;
}
.poc-table th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 2;
}
</style>
